/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router
    :default-active="$route.path + '?sorue=' + sorue" unique-opened class="el-menu-vertical-demo"
    background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox" @click="toHome">
      <img class="logoimg" src="../../static/image/logz_zr.png" alt="" />
    </div>
    <el-menu-item index="index" class="controlMenu">
      <i class="iconfont" :class="'li-icon-xiangmuguanli'"></i>
              <span slot="title">首页</span>
    </el-menu-item>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/' + chmenu.url + '?sorue=' + sorue" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{ chmenu.menuname }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: [],
      sorue: "",
    };
  },
  methods: {
    toHome() {
      this.$router.push({ path: "/dataMap/device" });
    },
    forWardPath(path) {
      let res = {
        // success: true,
        // data: [
        //   {
        //     menuid: 0,
        //     icon: "li-icon-xiangmuguanli",
        //     menuname: "演示",
        //     hasThird: null,
        //     url: null,
        //     menus: [
        //       {
        //         menuid: 2,
        //         icon: "icon-promotion-manage",
        //         menuname: "首页",
        //         hasThird: "N",
        //         url: "test/index",
        //         menus: null,
        //       }
        //     ],
        //   },
        // ],
        // msg: "success",
      };
      this.allmenu = res.data;

    },
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.sorue = this.$route.query.sorue;
    const href = window.location.href;
    if (href.indexOf("=") > 0) {
      let arr = href.split("=");
      this.sorue = arr[1].replace("%2F", "/");
    }
    this.forWardPath(this.sorue);
    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      this.collapsed = !value;
    });
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 215px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  /* height: 40px; */
  /* line-height: 40px; */
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 50px;
  width: 180px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue